import fetch from 'isomorphic-fetch';
import { checkStatus } from '../../util';
import { ROOT } from '../../../constants/root';

export function getAuthors() {
	return function(dispatch, getState) {		

		const URL = `${ROOT}/author/`;		

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			dispatch(setAuthorsList(json));
		})
		.catch((e) => {
			console.error(e);
		});
	};
}

function setAuthorsList(authors) {
	return {
		type: "SET_AUTHORS_LIST",
		authors
	};	
}


// WEBPACK FOOTER //
// ./src/state/domains/authors/actions.js